import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ResetPassword } from '../../../shared/models/rest-password.model';
import { HttpHelperService } from '../../../shared/services/http-helper.service';

@Injectable()
export class PasswordRecoveryRepository {
  private httpHelper: HttpHelperService;

  constructor(private http: HttpClient) {
    // create a local helper that will call the provided HttpClient (this keeps
    // existing unit tests which spy on HttpClient working unchanged)
    this.httpHelper = new HttpHelperService(this.http);
  }

  recoverPassword(userName: string): Observable<any> {
    const path = environment.user.recoverPassword;
    return this.httpHelper.post(path, { username: userName });
  }

  resetPassword(username: string, resetToken: string, passwords: ResetPassword): Observable<any> {
    const path = environment.user.resetPassword.replace('{username}', username).replace('{token}', resetToken);
    return this.httpHelper.post(path, passwords);
  }

  checkResetTokenValid(username: string, token: string): Observable<any> {
    const path = environment.user.checkResetPasswordToken.replace('{username}', username).replace('{token}', token);
    return this.httpHelper.get(path);
  }
}
